import React from "react";
/* Components */
import ShaiaBot from "../components/shaiaBot/shaiabot";
import RecoveryPassForm from "../components/form/recoveryPass";
import { useNavigate } from 'react-router-dom';
//import { useMixPanel } from '../hooks/useMixPanel';
import { useTranslation } from 'react-i18next';
import useUserStore from "../store/useUser.store";
import ToggleSwitch from '../components/form-elements/ToggleSwitch/toggleSwitch';

const RecoveryPassword = () => {
  const navigate = useNavigate();
  //const { sendEvent } = useMixPanel();
  const { t, i18n } = useTranslation();
  const { setLang } = useUserStore();
  //useEffect(() => {
    //sendEvent('SHAIA_RECOVERY_PASSWORD_VIEW');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  //},[])
  const onSwitch = (event) => {
    i18n.changeLanguage(event ? 'en' : 'es')
    setLang(event ? 'en' : 'es')
    localStorage.setItem('lang',event ? 'en' : 'es');
  };
  return (
    <div className="login-wrapper">
        <div className='fixed top-4 right-12 sm-max:top-8 sm-max:right-8'>
          <ToggleSwitch name='lang' onChange={onSwitch} />
        </div>
        <ShaiaBot />
        <RecoveryPassForm />
        <p className="user-account-link">
          😎 {t('haveAccount')}. {" "}
          <button onClick={() => navigate("/login")}>{t('logIn')}</button>
        </p>
        <div className='w-70/100 sm-max:w-full absolute bottom-4 left-1/2 -translate-x-1/2 flex flex-row sm-max:flex-col gap-1 items-center justify-center'>
          <p className="user-recovery-link w-auto flex flex-1 items-center justify-center gap-4 m-0">
            <button onClick={() => window.open("https://mentu.co/tratamiento-de-datos", '_blank', 'noopener,noreferrer')}>Tratamiento de Datos</button>
          </p>
          <p className="user-recovery-link w-auto flex flex-1 items-center justify-center gap-4 m-0">
            <button onClick={() => window.open("https://mentu.co/autorizacion-de-tratamiento-de-datos", '_blank', 'noopener,noreferrer')}>Autorizacion de Tratamiento de Datos</button>
          </p>
        </div>
    </div>
  );
};

export default RecoveryPassword;
